import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { useParams } from 'react-router-dom'

import Ticket from '../../components/Ticket/'
import TicketsManagerTabs from '../../components/TicketsManagerTabs/'

import { i18n } from '../../translate/i18n'

import { MessageCircle } from 'lucide-react'
import { useStyles } from './style'
import { useMediaQuery, useTheme } from '@material-ui/core'

const TicketsCustom = () => {
  const { ticketId } = useParams()
  const classes = useStyles({ ticketId })

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Grid className={classes.chatContainer}>
      <Grid className={classes.chatPapper}>
        <Grid container>
          {(!isMobile || (isMobile && !ticketId)) && (
            <Grid
              item
              xs={12}
              sm={5}
              md={4}
              xl={3}
              className={classes.contactsWrapper}
            >
              <TicketsManagerTabs />
            </Grid>
          )}

          {(!isMobile || (isMobile && ticketId)) && (
            <Grid
              item
              xs={12}
              sm={7}
              md={8}
              xl={9}
              className={classes.messagesWrapper}
            >
              {ticketId ? (
                <>
                  <Ticket />
                </>
              ) : (
                <Paper square variant="outlined" className={classes.welcomeMsg}>
                  <MessageCircle size={50} />
                  <span>{i18n.t('chat.noTicketMessage')}</span>
                </Paper>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default TicketsCustom
